import Header from '../components/Header'; 

const Layout = ({ children,  headerProps = {} }) => {
  return (
    <div>
      <Header {...headerProps} />
      <main style={{height: "calc(100vh - 83px)", overflowY: "auto", boxSizing: "border-box"}}>
        {children}
      </main>
    </div>
  );
};

export default Layout;